import axios from "axios";
import base from "./base";

/**
 * 接口地址统一从 base.js 读取
 * 切换本地/线上请修改 src/request/base.js 里的 USE_LOCAL
 */
axios.defaults.baseURL = base.baseUrl;

/**
 * 设置超时时间和跨域是否携带凭证
 */
axios.defaults.timeout = 10000;
axios.defaults.withCredentials = true;

/**
 * 设置请求传递数据的格式
 */
axios.defaults.headers['Content-Type'] = 'application/json';

/**
 * 请求拦截器
 * TOKEN校验
 * 优先级：localStorage 里的 token 优先；URL 上的 token 参数兜底。
 * 原实现用 href.substr(indexOf('token=') + 6) 硬截，会把 '&xxx=yyy' 一起当 token，
 * 这里改用 URLSearchParams 精确解析，只取 token 本身。
 */
axios.interceptors.request.use(config => {
    let token = '';
    try {
        token = localStorage.getItem('token') || '';
    } catch (e) {
        token = '';
    }
    // URL 上的 token 参数（如第三方跳转带 token 进来时）兜底
    const search = window.location.search;
    if (search) {
        const params = new URLSearchParams(search);
        const urlToken = params.get('token');
        if (urlToken) {
            token = urlToken;
            // 顺手把 URL 里的 token 存下来，后续请求直接走 localStorage
            try {
                localStorage.setItem('token', urlToken);
            } catch (e) {}
        }
    }
    config.headers.token = token;
    config.headers.tag = 'pc';
    return config;
}, error => {
    return Promise.reject(error);
});

/**
 * 响应拦截器
 */
axios.interceptors.response.use(response => {
    if (response.status == 200) {
        return response.data
    } else {
        console.log('请求错误:', response.data && response.data.msg)
        return Promise.reject(response)
    }
}, error => {
    let { response } = error;
    if (response) {
        switch (response.status) {
            case 401:
                localStorage.clear()
                console.log('401未授权:', response.data && response.data.msg)
                break;
            case 403:
                console.log('403禁止访问:', response.data && response.data.msg)
                break;
            case 404:
                console.log("未找到请求地址")
                break;
            default:
                console.log('请求错误:', response.statusText)
                break;
        }
    } else {
        if (!window.navigator.onLine) {
            console.log("网络连接异常")
        }
    }
    return Promise.reject(error);
});

export default axios;
